import uniqueId from 'lodash/uniqueId';

export default {
    props: {
        id: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        autocomplete: {
            type: String,
            default: 'on'
        },
        value: {
            type: String,
            default: null
        },
        error: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            inputId: null
        };
    },

    mounted() {
        this.inputId = this.id ? this.id : uniqueId('my_form_input_');
    }
};
